import { Fragment } from "react";
import "./css/legal.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import BannerDatos from "../../images/servicio/bg-cloud.webp";
import BannerDatosmobile from "../../images/servicio/bg-cloud-m.webp";
import HyundaiLogo from "../../images/assets/hyundai-logo.webp";
import Table from "react-bootstrap/Table";

function InfoPolitica() {
  return (
    <Fragment>
      <Container fluid={true} className="banner-legal">
        <Row>
          <Col md={12} className="px-0">
            <Card>
              <Image
                src={BannerDatos}
                alt="Hyundai Banner"
                title="Hyundai Banner"
                className="d-none d-sm-block img1"
                fluid
              />
              <Card.Img
                src={BannerDatosmobile}
                alt="Hyundai Banner"
                title="Hyundai Banner"
                className="d-block d-sm-none"
              />
              <Card.ImgOverlay className="d-flex">
                <Card.Title className="bg-banner-legal w-100 d-flex align-items-center">
                  <div className="mx-auto w-100">
                    <h1 className="legal-banner-titulo">
                      Política de privacidad.
                    </h1>
                    <br />
                    <h2 className="legal-banner-subtitulo">Hyundai Ecuador.</h2>
                  </div>
                </Card.Title>
              </Card.ImgOverlay>
            </Card>
          </Col>
        </Row>
      </Container>
      <Container className="legales">
        <Row>
          <Col md={12}>
            <Container className="pb-3">
              <Row>
                <Col md={12} className="mt-4 mt-md-5">
                  <Image
                    src={HyundaiLogo}
                    alt="Hyundai logo"
                    className="hyundai-logo"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12} className="mt-3">
                  <p className="legal-texto mt-1">
                    Este sitio web ha sido creado por Hyundai, representante oficial de la marca Hyundai en Ecuador
                    con carácter informativo y para uso personal. Accediendo a este sitio web y a la información que
                    en el se presenta el usuario acepta las siguientes cláusulas que a continuación se indican y que
                    definen los términos, condiciones y política de privacidad del presente sitio web y de todas sus
                    funcionalidades, contenidos e información que en él aparecen.
                  </p>
                  <p className="legal-texto-bold">
                    Aspectos generales
                  </p>
                  <p className="legal-texto">
                    El acceso a este sitio web y a sus funcionalidades es responsabilidad exclusiva de los usuarios.
                    El simple acceso a este sitio web no supone entablar ningún tipo de relación de carácter comercial
                    entre Hyundai Ecuador y el usuario.
                  </p>
                  <p className="legal-texto">
                    El acceso y navegación en este sitio web supone aceptar y conocer las advertencias legales, condiciones y
                    términos de uso contenidas en ella. La información que aparece en este sitio web es la vigente en la fecha
                    de su última actualización.
                  </p>
                  <p className="legal-texto">
                    Por regla general, el sitio web es solamente informativo, y las relaciones contractuales que deriven de la
                    información que recibe el usuario requerirán de su confirmación por escrito por parte de Hyundai Ecuador.
                  </p>
                  <p className="legal-texto-bold">
                    Modificación de la información
                  </p>
                  <p className="legal-texto">
                    Hyundai Ecuador se reserva la facultad y el derecho de actualizar, modificar o eliminar contenido o
                    información de este sitio web que estime convenientes, en parte o en el contenido total de este
                    sitio web, pudiendo hacer uso de tal facultad en cualquier momento y sin previo aviso.
                    Este derecho abarca los contenidos referidos a disponibilidad de modelos, colores, especificaciones,
                    precio, disponibilidad de productos o servicios, equipamiento o en cuanto a las funcionalidades
                    del sitio o de la información de actividades promocionales.
                  </p>
                  <p className="legal-texto">
                    Hyundai Ecuador se reserva la facultad de modificar unilateralmente las condiciones
                    y términos de uso de este sitio web. La entrada en vigor de las modificaciones de las condiciones
                    de uso se producirá desde el momento de su publicación en este sitio web.
                  </p>
                  <p className="legal-texto">
                    El tratamiento de los datos de carácter personal se hará conforme a lo previsto en la legislación vigente,
                    siendo estos datos almacenados y tratados con todas las garantías de seguridad que la tecnología
                    del momento permita.
                  </p>
                </Col>
              </Row>
            </Container>
            <Container className="mb-5 pb-3 mt-4 tabla-manual">
              <Row>
                <Col md={12}>
                  <Table responsive bordered hover>
                    <tbody>
                      <tr>
                        <td>
                          <a
                            href={`/static/media/proteccion.pdf`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="manual-link"
                          >
                            <h2><center>Política de protección de datos personales Neohyundai</center></h2>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}
export default InfoPolitica;